import "./aboutUs.css"
import Carousel from 'react-bootstrap/Carousel';
import ssa4 from "../../imagens/ssa/ssa4.png"
import ssa5 from "../../imagens/ssa/ssa5.JPG"
import ssa6 from "../../imagens/ssa/ssa6.JPG"
import ssa7 from "../../imagens/ssa/ssa7.JPG"
import aboutUsimage from "../../imagens/aboutUs/aboutUs.png"
import aboutUsimage2 from "../../imagens/aboutUs/aboutUs2.png"
import aboutUsimage3 from "../../imagens/aboutUs/aboutUs3.png"
import aboutUsimage4 from "../../imagens/aboutUs/aboutUs4.png"
import aboutUsimage6 from "../../imagens/aboutUs/aboutUs6.png"
import aboutUsimage7 from "../../imagens/aboutUs/aboutUs7.png"
import aboutUsimage8 from "../../imagens/aboutUs/aboutUs8.png"
import aboutUsimage9 from "../../imagens/aboutUs/aboutUs9.png"
import aboutUsimage10 from "../../imagens/aboutUs/aboutUs10.png"
import aboutUsimage11 from "../../imagens/aboutUs/aboutUs11.png"
import aboutUsimage12 from "../../imagens/aboutUs/aboutUs12.png"
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';



function AboutUs() {
  const { t } = useTranslation();

  return (
    <div className='container-fluid m-0 p-0' id="aboutUs">
      <div className="row m-0 d-flex align-items-center justify-content-around">
        <div className="col-lg-5 col-md-5  m-0 p-0 align-items-center TextAboutUsContactUs">
          <h1 className="text-center my-4 TextAboutUs">{t('about.heading')}</h1>
          <p className="px-4 TextAboutUs">{t('about.paragraph')}</p>
          <div className='text-center'>
            <div className="text-center">
              <Link to="/Capabilities">
                <button type="button" className="align-items-center buttonCapabilities">
                  {t('about.button')}
                  <FontAwesomeIcon className='ms-2' icon={faArrowRight} />
                </button>
              </Link>
            </div>
          </div>
        </div>
        <div className='col-lg-6 col-md-6 text-center mt-4 px-0 pt-3  '>
          <Carousel className='mx-2 mb-3'>
                <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={aboutUsimage}
                alt={t('about.imageAlt')}
              />
            </Carousel.Item>
                        <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={aboutUsimage11}
                alt={t('about.imageAlt')}
              />
            </Carousel.Item>
                        <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={aboutUsimage12}
                alt={t('about.imageAlt')}
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={ssa5}
                alt={t('about.imageAlt')}
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={ssa4}
                alt={t('about.imageAlt')}
              />
            </Carousel.Item>

            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={ssa6}
                alt={t('about.imageAlt')}
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={ssa7}
                alt={t('about.imageAlt')}
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={aboutUsimage2}
                alt={t('about.imageAlt')}
              />
            </Carousel.Item>

            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={aboutUsimage3}
                alt={t('about.imageAlt')}
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={aboutUsimage4}
                alt={t('about.imageAlt')}
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={aboutUsimage6}
                alt={t('about.imageAlt')}
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={aboutUsimage7}
                alt={t('about.imageAlt')}
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={aboutUsimage8}
                alt={t('about.imageAlt')}
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={aboutUsimage9}
                alt={t('about.imageAlt')}
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={aboutUsimage10}
                alt={t('about.imageAlt')}
              />
            </Carousel.Item>

          </Carousel>
        </div>
      </div>
    </div>
  )
}

export default AboutUs